import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-white" data-id="element-96">
      <div className="max-w-3xl mx-auto" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-cream-dark border-2 border-amber/20 p-10 md:p-16 rounded-[2.5rem] text-center relative overflow-hidden" data-id="element-98">
          <div className="absolute top-0 left-0 w-full h-2 bg-amber" data-id="element-99"></div>

          <div className="flex justify-center mb-8" data-id="element-100">
            <div className="bg-white p-4 rounded-full shadow-sm" data-id="element-101">
              <ShieldCheck className="w-12 h-12 text-amber" data-id="element-102" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-8" data-id="element-103">
            The Full 30-Day Peace of Mind Guarantee
          </h2>

          <div className="space-y-6 text-lg text-charcoal-light leading-relaxed" data-id="element-104">
            <p data-id="element-105">
              Read the entire guide. Apply the Crisis Calm Method for 30 days.
            </p>
            <p data-id="element-106">
              If you do not see a measurable reduction in meltdown frequency and
              intensity — if you do not feel more equipped, more confident and
              more connected to your child — contact us and you will receive a
              full refund. No questions asked. No hoops to jump through.
            </p>
            <p className="text-xl font-serif text-charcoal pt-4" data-id="element-107">
              The only risk here is staying exactly where you are right now.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}